import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Ruta pública con la que se puede acceder sin autenticación
 *
 * @param {Object} props - Propiedades del componente
 * @param {React.Component} props.children - Componente hijo
 * @param {Boolean} props.isAuthenticated - Autenticación
 * @returns {React.Component} Ruta pública
 */
export const PublicRoute = ({ children, isAuthenticated }) => {
  return !isAuthenticated ? children : <Navigate to="/" />;
};
